import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { CircularProgress, Box } from '@mui/material';

import { getSession } from './services/supabase';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Withdrawals from './pages/Withdrawals';
import Events from './pages/Events';
import Notices from './pages/Notices';
import ShellPieceGrants from './pages/ShellPieceGrants';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReferralLanding from './pages/ReferralLanding';
import Referrals from './pages/Referrals';
import EmergencyNotice from './pages/EmergencyNotice';
import PushNotifications from './pages/PushNotifications';
import Welcome from './pages/Welcome';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2D9500',
    },
    secondary: {
      main: '#2F3E55',
    },
  },
});

function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const session = await getSession();
      setIsAuthenticated(!!session);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/invite" element={<ReferralLanding />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="withdrawals" element={<Withdrawals />} />
            <Route path="events" element={<Events />} />
            <Route path="notices" element={<Notices />} />
            <Route path="shell-grants" element={<ShellPieceGrants />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="emergency" element={<EmergencyNotice />} />
            <Route path="push" element={<PushNotifications />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
